import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "../../../styles/Form.css";
import CustomProductForm from "./CustomvideoForm.js"; // Ensure the path is correct
import { FIELDS, MODE, TOAST_MESSAGES } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const AddVideo = () => {
  const navigate = useNavigate();
  const [iframePreview, setIframePreview] = useState("");

  // Define the fields for the form
  const videoFields = [
    { label: "Title", name: "title", placeholder: "Enter Title", required: true },
    { label: "Date", name: "date", type: "date", required: true },
    { label: "Time", name: "time", type: "time", required: true },
    { label: "Iframe", name: "iframe", placeholder: "Enter iframe embed code", required: true },
  ];

  const handleIframeChange = (e) => {
    const iframeCode = e.target.value;
    setIframePreview(iframeCode); // Update the iframe preview
  };

  const handleSubmit = async (formData) => {
    try {
      if (!formData.iframe) {
        toast.error("Iframe embed code is required");
        return;
      }

      formData.date = new Date(formData.date).toISOString();
      formData.views = 0;

      const response = await axios.post(`${API_URL}/video/createVideo`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      console.log("Video added successfully:", response.data);
      toast.success(TOAST_MESSAGES.DATA_SAVED);
      navigate("/videos");
    } catch (error) {
      console.error("Error adding video:", error);
      toast.error(TOAST_MESSAGES.ERROR_ADD);
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Video
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/videos")}
        >
          &times;
        </button>
      </div>
      <CustomProductForm
        mode={MODE.ADD}
        onSubmit={handleSubmit}
        fields={videoFields}
        iframePreview={iframePreview}
        handleFieldChange={handleIframeChange} // Custom handler for iframe field
      />
      {iframePreview && (
        <div className="iframe-preview">
          <h4>Iframe Preview</h4>
          <div dangerouslySetInnerHTML={{ __html: iframePreview }} />
        </div>
      )}
    </div>
  );
};

export default AddVideo;
